export default {"src":"/_next/static/media/segmentation_full.29f091c2.svg","height":160,"width":160};